// Service
import { checkPaymentService } from '../services/payment-landing-form.services';
// Types
import { CheckPaymentReturnType, CheckPaymentType } from '../handlers/utils/types/payment-landing-form.handlers.utils.type';
// Utilities
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const checkPaymentResolver = async (
  props: CheckPaymentType
): Promise<[CheckPaymentReturnType] | [null, boolean]> => {
  const [response, { status }] = await checkPaymentService(props);

  return requestHasSuccessStatus(status) ? [response] : [null, true];
};

export { checkPaymentResolver };
